import Logger from "../logging/logger.js";
export var EnvironmentType;
(function (EnvironmentType) {
    EnvironmentType[EnvironmentType["BROWSER"] = 0] = "BROWSER";
    EnvironmentType[EnvironmentType["NODE"] = 1] = "NODE";
    EnvironmentType[EnvironmentType["BOTH_FEATURES"] = 2] = "BOTH_FEATURES";
    EnvironmentType[EnvironmentType["UNKNOWN"] = 3] = "UNKNOWN";
})(EnvironmentType || (EnvironmentType = {}));
/** Environment class detects the runtime environment */
export default class Environment {
    /**
     * determines the runtime environment
     */
    static checkEnvironment() {
        const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
        const isNode = typeof global !== "undefined" &&
            typeof global.process !== "undefined" &&
            global.process.versions &&
            global.process.versions.node;
        if (isBrowser && isNode) {
            // Environment might be something like Electron
            Logger.info("This environment has features of both Node.js and a web browser.");
            this.environmentType = EnvironmentType.BOTH_FEATURES;
        }
        else if (isNode) {
            this.environmentType = EnvironmentType.NODE;
        }
        else if (isBrowser) {
            this.environmentType = EnvironmentType.BROWSER;
        }
        else {
            Logger.info("ENVIRONMENT === unknown");
            this.environmentType = EnvironmentType.UNKNOWN;
        }
    }
}
Environment.environmentType = EnvironmentType.UNKNOWN;
